import { makeStyles } from "tss-react/mui";

const GlobalPopupStyles = makeStyles()({
    close_button: {
        right: "0",
        width: "165px",
        height: "40px",
        background: "transparent",
        borderRadius: "5px",
        color: "#E36A6A",
        border: "1px solid #E36A6A",
        margin: "0 10px 0 0 !important",
        textTransform: "unset",
        "@media screen and (max-width:400px)": {
            width: "115px",
        },
        "@media screen and (max-width:367px)": {
            margin: "0 3px 0 0 !important",
        },
    },
    save_button: {
        right: "0",
        background: "#108F2C !important",
        color: "#ffffff !important",
        borderRadius: "5px",
        width: "165px",
        height: "40px",
        margin: "0 0 0 10px !important",
        textTransform: "unset",
        "@media screen and (max-width:400px)": {
            width: "115px",
        },
        "@media screen and (max-width:367px)": {
            margin: "0 0 0 3px !important",
        },
    },
    lastSection: {
        "@media screen and (max-width:367px)": {
            display: "flex",
            flexDirection: "column",
        },
    },
    VerifyButton: {
        background: "#43784A !important",
        color: "#ffffff !important",
        borderRadius: "5px",
        width: "83px",
        height: "40px",
        margin: "0 0 0 15px !important",
    },
    TitleBar: {
        background: "#3B78CE",
        color: "#FFFFFF !important",
        borderRadius: "0px",
        display: "flex",
        justifyContent: "center",
        "& .MuiTypography-root": {
            fontSize: "15px !important",
            fontWeight: "500 !important",
        },
        "&  .MuiButtonBase-root": {
            color: "#FFFFFF !important",
        },
    },
    Hello: {},
    ResendText: {
        margin: "0px !important",
        left: "0px !important",
    },
    upperSectionContainer: {
        "@media screen and (max-width: 750px)": {
            width: "100% !important",
        },
        "@media screen and (min-width: 450px) and (max-width: 550px)": {
            paddingLeft: "70px",
        },
        "@media screen and  (max-width: 750px)": {
            paddingLeft: "0px",
        },
    },
    upperSection: {
        flexWrap: "nowrap",
        "@media screen and (max-width:750px)": {
            justifyContent: "start",
        },
        "@media screen and (max-width:500px)": {
            flexDirection: "column",
            alignItems: "start",
            marginLeft: "0px !important",
        },
        "@media screen and (min-width:500px) and (max-width:550px)": {
            display: "flex",
            marginLeft: "0px !important",
            justifyContent: "start",
            "@media screen and (max-width: 721px) and (min-width: 550px)": {
                position: "relative",
                alignItems: "center !important",
                marginLeft: "0px",
            },
            "@media screen and (min-width:550px) and (max-width: 750px)": {
                transform: "translateX(0px) !important",
                alignItems: "center !important", // paddingRight:"80px !important"
            },
        },
    },
    upperSectionBottom: {
        justifyContent: "start",
        alignItems: "start",
        marginTop: "12px",
        paddingLeft: "39px",
        "@media screen and (max-width:750px)": {
            paddingLeft: "0px",
        },
        "@media screen and (max-width:672px)": {
            flexDirection: "column",
        },
        "@media screen and (max-width: 530px)": {
            marginLeft: "0px",
            alignItems: "flex-start !important",
        },
    },
    upperSection1: {
        "@media screen and (max-width:721px)": {
            display: "flex",
            flexDirection: "column",
            "@media screen and (max-width: 721px) and (min-width: 530px)": {
                position: "relative",
                left: "-22px",
                alignItems: "flex-end !important",
                marginLeft: "0px",
            },
        }
    },
    VerifyButtonBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        "@media screen and (min-width:450px) and (max-width:500px)": {
            width: "287px",
            marginTop: "10px",
        },
        "@media screen and (max-width:450px)": {
            width: "250px",
            marginTop: "10px",
        }
    },
    actionBox: {
        padding: " 0px !important",
    },
    dialogOuter: {
        zIndex: 500,
        "& .MuiPaper-root": {
            borderBottom: "4px solid #3B78CE !important",
            minWidth: "750px !important",
        },
    },
    dividers: {
        padding: "50px 30px 40px !important",
        "@media screen and (max-width:400px)": {
            padding: "30px 20px !important",
        },
    },
    getCallTextBox: {
        "@media screen and (min-width:625px)": {
            marginLeft: "15px !important",
            display: "flex",
            alignItems: "center",
            marginTop: "0px",
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        marginTop: "10px",
        position: "relative",
    },
    bottomBlock: {
        "@media screen and (min-width:625px)": {
            display: "flex",
        },
    },
    resendButtonContainer: {
        height: "50px",
        display: "flex",
        alignItems: "center",
        "@media screen and (max-width:530px)": {
            width: "100%",
        },
        "@media screen and (max-width:672px)": {
            marginTop: "10px",
            display: "flex",
            justifyContent: "flex-end",
        },
    },
    invalidOTPText: {
        position: "absolute",
        fontSize: "12px",
        marginTop: "7px",
        color: "#FF0000",
        "@media screen and (min-width:624px)": {
            bottom: "-22px",
        },
    },
    textStyle: {
        color: "#000",
        fontSize: "14px",
        fontWeight: "600",
    },
    selectStyle: {
        minWidth: "287px",
    },
    inputLabelStyle: {
        fontSize: "15px",
        fontWeight: "600",
        color: "#000",
        marginBottom: "10px",
    },
    subHeadingAnalysisResult: {
        width: "100%",
        display: "flex",
        padding: "10px 20px",
        justifyContent: "space-between",
        alignItems: "center",
        height: "auto",
    },
    warningImage: {
        width: "87px",
        height: "77px",
        marginBottom: "56px",
    }
});

export default GlobalPopupStyles;